import { factory, sequence, random } from 'stahlwerk';

export const createWorkTimeRule = factory({
  id: sequence(),
  type: random(['break', 'rounding']),
  name: 'a random name',
  description: 'description',
});
